import { Box, Typography, Button, Chip } from "@mui/material";

// summary_status display text, matching DischargeSummaryModal's chip labels.
const LABELS = {
  draft: "Draft",
  pending_approval: "Pending Approval",
  approved: "Approved",
  rejected: "Rejected",
};

/**
 * The discharge summary's approval state, shown at every stage of the discharge.
 *
 * Billing cannot clear a discharge until the summary is approved, and that gate
 * is enforced server-side. Before this band existed the doctor's console said
 * "awaiting Billing desk clearance" while the billing queue said "awaiting
 * doctor's summary approval" — each screen blaming the other, with the real
 * blocker named on neither, and the discharge stalled between them.
 *
 * It renders at every stage rather than only at `ward` because the bug above
 * has already stranded rows at `billing` with an unapproved summary, and those
 * need a route out too.
 *
 * `onOpenSummary` is optional: only the doctor's console can open the wizard.
 * Where it is absent (the nurse dashboard) the band is informational.
 */
const SummaryStatusBand = ({ summaryStatus, onOpenSummary }) => {
  const approved = summaryStatus === "approved";
  const label = LABELS[summaryStatus] || summaryStatus || "Not started";

  return (
    <Box
      sx={{
        border: 1,
        borderColor: approved ? "success.light" : "warning.main",
        borderRadius: 1,
        p: 1.5,
        mb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: approved ? 0 : 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Discharge summary:
        </Typography>
        <Chip size="small" color={approved ? "success" : "warning"} label={label} />
      </Box>

      {!approved && (
        <>
          <Typography variant="body2" sx={{ mb: onOpenSummary ? 1 : 0 }}>
            Billing cannot clear this discharge until the summary is approved.
          </Typography>
          {onOpenSummary && (
            <Button variant="outlined" size="small" color="warning" onClick={onOpenSummary}>
              Open Discharge Summary
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default SummaryStatusBand;
